import { FETCH_SPOT_CONTACTS_BC_FAILURE, FETCH_SPOT_CONTACTS_BC_REQUEST, FETCH_SPOT_CONTACTS_BC_SUCCESS } from "../../actions/targetedReachout/spotContactBattleCardActions";

  const initialState = {
    spotContactBCLoading: true,
    spotContactBCData: [],
    spotContactBCError: null,
  };
  
  const spotContactBCReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SPOT_CONTACTS_BC_REQUEST:
        return { ...state, spotContactBCLoading: true , payload: action.payload};
      case FETCH_SPOT_CONTACTS_BC_SUCCESS:
        return { ...state, spotContactBCLoading: false, spotContactBCData: action.payload };
      case FETCH_SPOT_CONTACTS_BC_FAILURE:
        return { ...state, spotContactBCLoading: false, spotContactBCError: action.payload };       
      default:
        return state;
    }
  };
  
  export default spotContactBCReducer;
  
